import { Link } from "react-router-dom";

const CambiarContraseña = ({
    form,
    onClick,
    onChange,
    loading,
    show,
    setShow
  }) => {
  
    return (
      <section class="min-vh-100" style={{ backgroundColor: "#eaeaea" }}>
        <div class="container min-vh-100 d-flex justify-content-center align-items-center py-5">
          <div class="row">
            <div class="col col-xl-12 w-100">
              <div class="bg-light shadow-sm" style={{ borderRadius: "1rem" }}>
                <div class="row g-0">
                  <div class="col-md-12 col-lg-12 d-flex align-items-center">
                    <div class="p-5 p-lg-5 text-black">
                      <form className="mb-3">
                        <div class="d-flex align-items-center mb-1 pb-1">
                          <span
                            class="h1 fw-bold mb-0"
                            style={{ width: "130px" }}
                          >
                            <img
                              src="/assets/img/marca/antesala-logo.svg"
                              className="img-fluid"
                              alt=""
                            />
                          </span>
                        </div>
  
                        <h3
                          class="fw-normal mb-3 pb-3"
                          style={{ letterSpacing: "1px" }}
                        ></h3>
  
                        
                      <div class="form-outline mb-2">
                        <label class="form-label" for="form2Example27">
                          Contraseña
                        </label>
                        <div class="input-group mb-3">
                          <label className="input-group-text border-0 px-3" style={{ cursor: 'pointer' }}>
                            {show ? (
                              <i className="bi bi-eye"></i>
                            ) : (
                              <i className="bi bi-eye-slash"></i>
                            )}
                            <button
                              className="d-none"
                              type="button"
                              id="basic-addon1"
                              name="show"
                              onClick={(event) => {
                                event.preventDefault();
                                setShow(!show);
                              }}
                            ></button>
                          </label>
                          <input
                            type={show ? "text" : "password"}
                            class="form-control"
                            aria-label="Password"
                            aria-describedby="basic-addon1"
                            name="password"
                            placeholder="Mínimo 8 caracteres"
                            onChange={(event) => onChange(event)}
                          />
                        </div>
                      </div>

                      <div class="form-outline mb-2">
                        <label class="form-label" for="form2Example27">
                          Repetir Contraseña
                        </label>
                        <div class="input-group mb-3">
                          <label className="input-group-text border-0 px-3" style={{ cursor: 'pointer' }}>
                            {show ? (
                              <i className="bi bi-eye"></i>
                            ) : (
                              <i className="bi bi-eye-slash"></i>
                            )}
                            <button
                              className="d-none"
                              type="button"
                              id="basic-addon1"
                              name="show"
                              onClick={(event) => {
                                event.preventDefault();
                                setShow(!show);
                              }}
                            ></button>
                          </label>
                          <input
                            type={show ? "text" : "password"}
                            class="form-control"
                            aria-label="Password"
                            aria-describedby="basic-addon1"
                            name="confirm_password"
                            placeholder="Repite la contraseña"
                            onChange={(event) => onChange(event)}
                          />
                        </div>
                      </div>
  
                        <div class="pt-1 mb-4">
                          <label
                            class="btn btn-dark btn-lg btn-block w-100"
                            style={{ cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}
                          >
                            {loading ? (
                              <span className="d-flex align-items-center justify-content-center">
                                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Cambiando contraseña...
                              </span>
                            ) : (
                              "Cambiar contraseña"
                            )}
                            <button
                              className="d-none"
                              type="button"
                              name="enviar"
                              onClick={(event) => onClick(event)}
                              disabled={loading}
                            ></button>
                          </label>
                        </div>
                      </form>

                      <p class="mb-5 pb-lg-2" style={{ color: "#393f81" }}>
                        ¿Ya tienes una cuenta?{" "}
                        <Link to="/login" style={{ color: "#393f81" }}>
                          Ingresa.
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  };
  
  export default CambiarContraseña;